iScreenWizard.controller('ELearningController', function ($scope, $state, $mdDialog, Ajax, Dictionary, WizardContent, userService) {

    $scope.content = '';
    $scope.user = userService.model;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        refresh();
    });

    var refresh = function() {
        WizardContent.eLearning().then(function (eLearning) {
            $scope.content = eLearning.inhoud;
        });
    };

});